import { render, staticRenderFns } from "./interview-add.vue?vue&type=template&id=32914941&scoped=true&"
import script from "./interview-add.vue?vue&type=script&lang=js&"
export * from "./interview-add.vue?vue&type=script&lang=js&"
import style0 from "./interview-add.vue?vue&type=style&index=0&id=32914941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32914941",
  null
  
)

export default component.exports